import React from 'react'

import { DashboardBackButton } from '@components/utils'
import { Dropdown, Heading, ToolbarButton } from '@fourthwall/components'
import { DotsHorizontalIcon } from '@fourthwall/icons'
import { routing } from '@utils/routing'

import * as S from './Header.styled'

type HeaderProps = {
  title: string
  description: string
  onEdit: () => void
  onRemove: () => void
}

export const Header = ({ title, description, onEdit, onRemove }: HeaderProps) => (
  <>
    <DashboardBackButton label="Members-only Spotify podcast" to={routing.apps.spotify.self} />
    <S.Container>
      <S.Top>
        <S.HeadingContainer>
          <Heading type="h2" weight="semibold">
            {title}
          </Heading>
        </S.HeadingContainer>
        <Dropdown
          content={
            <>
              <Dropdown.Item label="Edit podcast details" onClick={onEdit} />
              <Dropdown.Item label="Remove podcast" onClick={onRemove} />
            </>
          }
          position="bottom-end"
        >
          <ToolbarButton icon={DotsHorizontalIcon} />
        </Dropdown>
      </S.Top>
      <S.Description>{description}</S.Description>
    </S.Container>
  </>
)
